export const convertGramsToTons = (grams: number, decimal: number) => +(grams / 1000000).toFixed(decimal);
